<template>
    <MainHeader app="sales" @centerSelected="loadCenter()" />

    <!-- Knowledge base -->
    <div
        class="modal-holder sales-modal sales-knowledge-bank"
        v-if="authStore.showFAQ"
    >
        <div class="modal-card">
            <div class="modal-header-card">
                <div>
                    <h3>Kunskapsbanken</h3>
                </div>
            </div>
            <div class="modal-content scroll-bar">
                <h4>Kunskap ger ökad försäljning</h4>
                <p>
                    Actics kunskapsbanks utbildningsmaterial och verktyg ger dig
                    djupare insikt i produkterna och försäljningsstrategier, så
                    förbättrar din förmåga att tillgodose kundbehovet, vilket
                    leder till ökad försäljning.
                </p>

                <div class="accordion">
                    <!-- Current campaigns -->
                    <div
                        v-for="(article, index) in settings?.knowledgeBank"
                        class="accordion-item"
                        :class="[
                            accordionsOpen.indexOf('knowledgeBank_' + index) >
                            -1
                                ? 'open'
                                : '',
                        ]"
                    >
                        <div
                            class="accordion-item-header"
                            @click="toggleAccordion('knowledgeBank_' + index)"
                        >
                            <h4>{{ article.name }}</h4>
                            <div>
                                <i class="material-icons-outlined"
                                    >expand_more</i
                                >
                            </div>
                        </div>
                        <div
                            class="accordion-item-content"
                            v-html="article.info"
                        ></div>
                    </div>
                </div>
            </div>
            <div class="modal-buttons">
                <div class="buttons button-holder-right">
                    <button @click="authStore.showFAQ = false" class="button">
                        Stäng
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Clipcard info-->
    <div class="modal-holder sales-modal" v-if="exerpError">
        <div class="modal-card">
            <div class="modal-card-header">
                <div>
                    <h3>Ingen kontakt med Exerp</h3>
                </div>
            </div>
            <div class="modal-content scroll-bar">
                Tyvärr får vi ingen kontakt med Exerp just nu. Försök igen
                senare.
            </div>
            <div class="modal-buttons">
                <div class="buttons button-holder-right">
                    <button @click="exerpError = false" class="button">
                        Avbryt
                    </button>
                    <button @click="reloadPage()" class="button">
                        Ladda om sidan
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Clipcard info-->
    <div class="modal-holder sales-modal" v-if="showInfoBox == 'clipcard'">
        <div class="modal-card">
            <div class="modal-card-header">
                <div>
                    <h3>{{ clipcardInfo.name }}</h3>
                </div>
            </div>
            <div
                class="modal-content scroll-bar"
                v-html="clipcardInfo.info"
            ></div>
            <div class="modal-buttons">
                <div class="buttons button-holder-right">
                    <button @click="showInfoBox = false" class="button">
                        Stäng
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Single site info-->
    <div class="modal-holder sales-modal" v-if="showInfoBox == 'local'">
        <div class="modal-card">
            <div class="modal-card-header">
                <div>
                    <h3>Single Site</h3>
                    <label>{{ sales?.subscriptions?.center?.name }}</label>
                </div>
            </div>
            <div class="modal-content scroll-bar">
                <div
                    class="modal-info-content"
                    v-if="getDefaultText('local')"
                    v-html="getDefaultText('local')"
                ></div>

                <div class="sales-company-codes-header">
                    <h5>Detta ingår i medlemskapet</h5>
                </div>
                <div class="sales-company-codes sales-subscription-features">
                    <div
                        class="sales-company-code"
                        v-for="feature in sales?.subscriptions?.center
                            ?.features"
                    >
                        <span>{{ feature }}</span>
                    </div>
                </div>
            </div>
            <div class="modal-buttons">
                <div class="buttons button-holder-right">
                    <button @click="showInfoBox = false" class="button">
                        Stäng
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Region info-->
    <div class="modal-holder sales-modal" v-if="showInfoBox == 'region'">
        <div class="modal-card">
            <div class="modal-card-header">
                <div>
                    <h3>Regionen</h3>
                    <label>{{ sales?.subscriptions?.regionInfo?.name }}</label>
                </div>
            </div>
            <div class="modal-content scroll-bar">
                <div
                    class="modal-info-content"
                    v-if="getDefaultText('region')"
                    v-html="getDefaultText('region')"
                ></div>

                <div class="sales-company-codes-header">
                    <h5>Detta ingår i medlemskapet</h5>
                </div>
                <div class="sales-company-codes sales-subscription-features">
                    <div
                        class="sales-company-code"
                        v-for="feature in sales?.subscriptions?.region
                            ?.features"
                    >
                        <span>{{ feature }}</span>
                    </div>
                </div>

                <div class="sales-company-codes-header">
                    <h5>
                        Dessa gym ingår i medlemskapet ({{
                            sales?.subscriptions?.regionInfo?.centers.length
                        }}st)
                    </h5>
                </div>

                <div class="sales-company-codes">
                    <div
                        class="sales-company-code"
                        v-for="center in sales?.subscriptions?.regionInfo
                            ?.centers"
                    >
                        <span
                            ><a href="#">{{ center.shortName }}</a
                            ><br />
                            <span class="sales-city-name">{{
                                center.city
                            }}</span></span
                        >
                    </div>
                </div>
            </div>
            <div class="modal-buttons">
                <div class="buttons button-holder-right">
                    <button @click="showInfoBox = false" class="button">
                        Stäng
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Max info -->
    <div class="modal-holder sales-modal" v-if="showInfoBox == 'max'">
        <div class="modal-card">
            <div class="modal-card-header">
                <div>
                    <h3>Hela norden</h3>
                    <label>{{ sales?.subscriptions?.regionInfo?.name }}</label>
                </div>
            </div>
            <div class="modal-content scroll-bar">
                <div
                    class="modal-info-content"
                    v-if="getDefaultText('max')"
                    v-html="getDefaultText('max')"
                ></div>

                <div class="sales-company-codes-header">
                    <h5>Detta ingår i medlemskapet</h5>
                </div>
                <div class="sales-company-codes sales-subscription-features">
                    <div
                        class="sales-company-code"
                        v-for="feature in sales?.subscriptions?.center
                            ?.features"
                    >
                        <span>{{ feature }}</span>
                    </div>
                    <div class="sales-company-code">
                        <span>{{ getNumberOfBath() }} bad</span>
                    </div>
                </div>

                <div class="sales-company-codes-header">
                    <h5>
                        Dessa gym ingår i medlemskapet ({{
                            sales?.subscriptions?.maxInfo?.centers.length
                        }}st)
                    </h5>
                </div>

                <div class="sales-company-codes">
                    <div
                        class="sales-company-code"
                        v-for="center in sales?.subscriptions?.maxInfo?.centers"
                    >
                        <span
                            ><a href="#">{{ center.shortName }}</a
                            ><br />
                            <span class="sales-city-name">{{
                                center.city
                            }}</span></span
                        >
                    </div>
                </div>
            </div>
            <div class="modal-buttons">
                <div class="buttons button-holder-right">
                    <button @click="showInfoBox = false" class="button">
                        Stäng
                    </button>
                </div>
            </div>
        </div>
    </div>

    <main class="main">
        <div v-if="checkoutSuccess">
            <div class="sales-header">
                <h1>Klart!</h1>
            </div>

            <div class="sales">
                <div class="sales-holder sales-success">
                    <i class="material-icons-outlined sales-success-icon"
                        >task_alt</i
                    >
                    <p>Produktförslaget har skickats till kund via sms.</p>

                    <!-- Målsman -->
                    <ul class="sales-info-box" v-if="customer.otherPayer">
                        <li>
                            <span>Målsman: Namn</span>
                            <span
                                >{{ customer.otherPayerName }}
                                {{ customer.otherPayerLastName }}</span
                            >
                        </li>
                        <li>
                            <span>Målsman: Telefon</span>
                            <span>{{ customer.otherPayerPhone }}</span>
                        </li>
                        <li>
                            <span>Målsman: E-post</span>
                            <span>{{ customer.otherPayerEmail }}</span>
                        </li>
                    </ul>

                    <ul class="sales-info-box">
                        <li>
                            <span>Namn</span>
                            <span
                                >{{ customer.name }}
                                {{ customer.lastName }}</span
                            >
                        </li>
                        <li>
                            <span>Telefon</span>
                            <span>{{ customer.phone }}</span>
                        </li>
                        <li>
                            <span>E-post</span>
                            <span>{{ customer.email }}</span>
                        </li>
                    </ul>

                    <!-- Subscription info -->
                    <ul
                        class="sales-info-box sales-info-box-last"
                        v-if="selectedProduct?.clips === undefined"
                    >
                        <li
                            v-if="
                                selectedProduct?.subscriptionBinding === '12M'
                            "
                        >
                            <span>Bindningstid</span>
                            <span>12 mån</span>
                        </li>
                        <li
                            v-if="
                                selectedProduct?.subscriptionBinding !== '12M'
                            "
                        >
                            <span>Bindningstid</span>
                            <span>-</span>
                        </li>
                        <li>
                            <span>Medlemstyp</span>
                            <span>{{
                                sales.subscriptions?.personTypeLabel
                            }}</span>
                        </li>
                        <li>
                            <span>Hemmagym</span>
                            <span class="color-blue">
                                {{ sales.subscriptions?.center?.name }}
                            </span>
                        </li>
                        <li>
                            <span>Tillgångsnivå</span>
                            <span>{{ selectedProduct?.areaLabel }}</span>
                        </li>
                        <li>
                            <span>Ingår</span>
                            <span>
                                {{ selectedProduct?.includes.join(", ") }}
                            </span>
                        </li>
                        <li v-if="selectedProduct?.campaign?.summary">
                            <span>Erbjudande</span>
                            <span
                                class="color-red"
                                v-html="selectedProduct?.campaign?.summary"
                            ></span>
                        </li>
                        <li>
                            <span>Månadskostnad</span>
                            <span class="sales-info-box-price"
                                >{{ selectedProduct?.periodPrice }}kr/mån</span
                            >
                        </li>
                    </ul>
                    <!-- End of subscription info-->

                    <!-- Clipcard info -->
                    <ul
                        class="sales-info-box sales-info-box-last"
                        v-if="selectedProduct?.clips !== undefined"
                    >
                        <li>
                            <span>Produkt</span>
                            <span>{{ selectedProduct.name }}</span>
                        </li>
                        <li>
                            <span>Pris</span>
                            <span>{{ selectedProduct.price }}</span>
                        </li>
                    </ul>
                    <!-- End of clipcard info-->

                    <div class="button-holder-center">
                        <div class="button" @click="reload()">Stäng</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-holder sales-modal" v-if="showCompanySearchResults">
            <div class="modal-card">
                <div class="modal-card-header">
                    <h3>Sök Företagsavtal</h3>
                </div>
                <div class="modal-content scroll-bar">
                    <div class="sales-company-codes-header">
                        <h5>Resultat</h5>
                    </div>
                    <p
                        class="sales-modal-small-text"
                        v-if="companySearchResults?.length === 0"
                    >
                        Tyvärr hittade vi inga företagsavtal på din sökning "{{
                            companySearch
                        }}" på {{ authStore.user.current_center.name }}
                    </p>

                    <div
                        class="sales-company-codes"
                        v-if="companySearchResults?.length > 0"
                    >
                        <div
                            class="sales-company-code"
                            :class="[
                                CompanyAgreement.agreement.state !== 'ACTIVE'
                                    ? 'is-not-active'
                                    : '',
                            ]"
                            v-for="CompanyAgreement in companySearchResults"
                        >
                            <span>{{ CompanyAgreement.company.name }}</span>
                            <span>{{ CompanyAgreement.agreement.name }}</span>
                            <div>
                                <span>{{
                                    CompanyAgreement.agreement.agreementCode
                                }}</span>
                                <button
                                    @click="
                                        selectCompanyCode(
                                            CompanyAgreement.agreement
                                                .agreementCode
                                        )
                                    "
                                    v-if="
                                        CompanyAgreement.agreement.state ===
                                        'ACTIVE'
                                    "
                                    class="button"
                                >
                                    Använd
                                </button>
                                <button
                                    v-if="
                                        CompanyAgreement.agreement.state !==
                                        'ACTIVE'
                                    "
                                    class="button button-disabled"
                                >
                                    Använd
                                </button>
                            </div>
                        </div>
                        <p class="sales-modal-small-text">
                            {{ companySearchResults?.length }} resultat hittades
                            för din sökning på "{{ companySearch }}" på
                            {{ authStore.user.current_center.name }}
                        </p>
                    </div>
                </div>
                <div class="modal-buttons">
                    <div class="buttons button-holder-right">
                        <button
                            @click="showCompanySearchResults = false"
                            class="button"
                        >
                            Stäng
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="showCheckoutForm && !checkoutSuccess">
            <div class="sales-header">
                <h1>Kunduppifter</h1>
            </div>

            <div class="sales">
                <form class="sales-holder" @submit.prevent="checkout()">


                    <div class="sales-form-header">
                        <h3>Varukorg</h3>
                        <div @click="deleteProduct()"><i class="material-icons-outlined color-blue"
                                >delete</i
                            ></div>
                    </div>


                    <!-- Subscription info -->
                    <ul
                        class="sales-info-box sales-info-box-last"
                        v-if="selectedProduct?.clips === undefined"
                    >
                        <li
                            v-if="
                                selectedProduct?.subscriptionBinding === '12M'
                            "
                        >
                            <span>Bindningstid</span>
                            <span>12 mån</span>
                        </li>
                        <li
                            v-if="
                                selectedProduct?.subscriptionBinding !== '12M'
                            "
                        >
                            <span>Bindningstid</span>
                            <span>-</span>
                        </li>
                        <li>
                            <span>Medlemstyp</span>
                            <span>{{
                                sales.subscriptions?.personTypeLabel
                            }}</span>
                        </li>
                        <li>
                            <span>Hemmagym</span>
                            <span class="color-blue">
                                {{ sales.subscriptions?.center?.name }}
                            </span>
                        </li>
                        <li>
                            <span>Tillgångsnivå</span>
                            <span>{{ selectedProduct?.areaLabel }}</span>
                        </li>
                        <li>
                            <span>Ingår</span>
                            <span>
                                {{ selectedProduct?.includes.join(", ") }}
                            </span>
                        </li>
                        <li v-if="selectedProduct?.campaign?.summary">
                            <span>Erbjudande</span>
                            <span
                                class="color-red"
                                v-html="selectedProduct?.campaign?.summary"
                            ></span>
                        </li>
                        <li>
                            <span>Månadskostnad</span>
                            <span class="sales-info-box-price"
                                >{{ selectedProduct?.periodPrice }}kr/mån</span
                            >
                        </li>
                    </ul>
                    <!-- End of subscription info-->

                    <!-- Clipcard info -->
                    <ul
                        class="sales-info-box sales-info-box-last"
                        v-if="selectedProduct?.clips !== undefined"
                    >
                        <li>
                            <span>Produkt</span>
                            <span>{{ selectedProduct.name }}</span>
                        </li>
                        <li>
                            <span>Pris</span>
                            <span>{{ selectedProduct.price }}</span>
                        </li>
                    </ul>
                    <!-- End of clipcard info-->

                    <div class="sales-form-header">
                        <h3>Kontaktuppgifter</h3>
                        <div>* Är obligatoriskt</div>
                    </div>

                    <div class="input-holder">
                        <input
                            v-model="customer.name"
                            type="text"
                            placeholder="Förnamn"
                        />
                    </div>
                    <div class="input-holder">
                        <input
                            v-model="customer.lastname"
                            type="text"
                            placeholder="Efternamn"
                        />
                    </div>

                    <div class="input-holder">
                        <input
                            v-model="customer.phone"
                            type="text"
                            :class="[
                                customerErrors.indexOf('phone') > -1
                                    ? 'error'
                                    : '',
                            ]"
                            placeholder="Telefonnummer *"
                            @input="removeCustomerError('phone')"
                        />
                        <span v-if="customerErrors.indexOf('phone') != -1"
                            >Fyll i ett telefonnummer</span
                        >
                    </div>

                    <div class="input-holder">
                        <input
                            v-model="customer.email"
                            type="text"
                            placeholder="E-postadress"
                        />
                    </div>

                    <div class="sales-other-payer-holder">
                        <label class="label-checkbox">
                            <input
                                type="checkbox"
                                :value="true"
                                v-model="customer.otherPayer"
                            />
                            <div class="checkbox"></div>
                            Målsman
                        </label>

                        <button
                            class="button"
                            v-if="!customer.otherPayer"
                            type="submit"
                        >
                            Spara och skicka
                        </button>
                    </div>

                    <div v-if="customer.otherPayer">
                        <div class="sales-form-header">
                            <h3>Kontaktuppgifter för målsman</h3>
                            <div>* Är obligatoriskt</div>
                        </div>
                        <div class="input-holder">
                            <input
                                v-model="customer.otherPayerName"
                                type="text"
                                placeholder="Förnamn"
                            />
                        </div>
                        <div class="input-holder">
                            <input
                                v-model="customer.otherPayerLastname"
                                type="text"
                                placeholder="Efternamn"
                            />
                        </div>

                        <div class="input-holder">
                            <input
                                v-model="customer.otherPayerPhone"
                                type="text"
                                placeholder="Telefonnummer *"
                                :class="[
                                    customerErrors.indexOf('otherPayerPhone') >
                                    -1
                                        ? 'error'
                                        : '',
                                ]"
                                @input="removeCustomerError('otherPayerPhone')"
                            />
                            <span
                                v-if="
                                    customerErrors.indexOf('otherPayerPhone') !=
                                    -1
                                "
                                >Fyll i ett telefonnummer</span
                            >
                        </div>

                        <div class="input-holder">
                            <input
                                v-model="customer.otherPayerEmail"
                                type="text"
                                placeholder="E-postadress"
                            />
                        </div>
                    </div>

                    <div
                        class="buttons button-holder-right"
                        v-if="customer.otherPayer"
                    >
                        <button class="button" type="submit">
                            Spara och skicka
                        </button>
                    </div>
                </form>
            </div>
        </div>

        <div v-if="!showCheckoutForm && !checkoutSuccess">
            <div class="sales-header">
                <h1>Nytt medlemskap</h1>
            </div>
            <div class="sales">
                <!-- Persontype -->
                <div class="sales-holder">
                    <div class="sales-person-types">
                        <div class="sales-person-type">
                            <label>
                                <input
                                    type="radio"
                                    value="private"
                                    v-model="personType"
                                    @change="loadProducts()"
                                />
                                Ordinarie
                            </label>
                        </div>

                        <div class="sales-person-type">
                            <label>
                                <input
                                    type="radio"
                                    value="student"
                                    v-model="personType"
                                    @change="loadProducts()"
                                />
                                Student
                            </label>
                        </div>

                        <div class="sales-person-type">
                            <label>
                                <input
                                    type="radio"
                                    value="senior"
                                    v-model="personType"
                                    @change="loadProducts()"
                                />
                                Senior
                            </label>
                        </div>
                    </div>

                    <!-- Accordions -->
                    <div class="accordion">
                        <!-- Current campaigns -->
                        <div
                            class="accordion-item"
                            :class="[
                                accordionsOpen.indexOf('currentCampaigns') > -1
                                    ? 'open'
                                    : '',
                            ]"
                        >
                            <div
                                class="accordion-item-header"
                                @click="toggleAccordion('currentCampaigns')"
                            >
                                <h4>Aktuella kampanjer</h4>
                                <div>
                                    <i class="material-icons-outlined"
                                        >expand_more</i
                                    >
                                </div>
                            </div>
                            <div class="accordion-item-content">
                                <div
                                    class="sales-info-campaign"
                                    v-for="campaign in settings?.campaigns"
                                >
                                    <h4>{{ campaign.name }}</h4>
                                    <div v-html="campaign.info"></div>
                                    <span
                                        class="code"
                                        @click="
                                            addPreDefinedCampaignCode(
                                                campaign.code
                                            )
                                        "
                                        >Använd kod: {{ campaign.code }}</span
                                    >
                                </div>
                            </div>
                        </div>

                        <!-- Campaigncode -->
                        <div
                            class="accordion-item"
                            :class="[
                                accordionsOpen.indexOf('campaignCode') > -1
                                    ? 'open'
                                    : '',
                            ]"
                        >
                            <div
                                class="accordion-item-header"
                                @click="toggleAccordion('campaignCode')"
                            >
                                <div>
                                    <h4>Kampanjkod</h4>
                                    <i
                                        v-if="selectedCampaign"
                                        class="material-icons-outlined"
                                        >check</i
                                    >
                                </div>
                                <div>
                                    <i class="material-icons-outlined"
                                        >expand_more</i
                                    >
                                </div>
                            </div>
                            <div class="accordion-item-content">
                                <p class="color-rock">
                                    Ange din kampanjkod här nedan för att sedan
                                    gå vidare med din rabatt i köpflödet
                                </p>
                                <form
                                    class="sales-campaign-holder"
                                    @submit.prevent="addCampaignCode()"
                                >
                                    <input
                                        :readonly="selectedCampaign"
                                        type="text"
                                        v-model="campaignCode"
                                        placeholder="Fyll i kampanjkod"
                                    />
                                    <button
                                        class="sales-campaign-activate button"
                                        :class="[
                                            campaignCode === '' ||
                                            selectedCampaign
                                                ? 'button-disabled'
                                                : '',
                                        ]"
                                    >
                                        Aktivera
                                    </button>
                                </form>
                                <div
                                    class="sales-selected-campaign"
                                    v-if="selectedCampaign"
                                >
                                    <h4>{{ selectedCampaign.name }}</h4>
                                    <h5 class="color-rock">
                                        Giltig mellan
                                        {{ selectedCampaign.dateInterval.from }}
                                        - {{ selectedCampaign.dateInterval.to }}
                                    </h5>
                                    <div
                                        class="button button-extra-small"
                                        @click="campaignRemove()"
                                    >
                                        Ta bort kampanjkod
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Companycode -->
                        <div
                            class="accordion-item"
                            :class="[
                                accordionsOpen.indexOf('companyCode') > -1
                                    ? 'open'
                                    : '',
                            ]"
                        >
                            <div
                                class="accordion-item-header"
                                @click="toggleAccordion('companyCode')"
                            >
                                <h4>Företagsavtal</h4>
                                <div>
                                    <i class="material-icons-outlined"
                                        >expand_more</i
                                    >
                                </div>
                            </div>
                            <div class="accordion-item-content">
                                <p class="color-rock">
                                    Ange din företagskod här nedan för att sedan
                                    gå vidare med din rabatt i köpflödet
                                </p>
                                <div class="sales-campaign-holder">
                                    <input
                                        type="text"
                                        v-model="companyCode"
                                        placeholder="Fyll i kampanjkod"
                                    />
                                    <button
                                        class="sales-campaign-activate button"
                                        :class="[
                                            companyCode === ''
                                                ? 'button-disabled'
                                                : '',
                                        ]"
                                    >
                                        Aktivera
                                    </button>
                                </div>
                                <form
                                    @submit.prevent="searchCompany()"
                                    class="sales-campaign-holder"
                                >
                                    <input
                                        type="text"
                                        v-model="companySearch"
                                        placeholder="Företagsnamn"
                                    />
                                    <button
                                        class="sales-campaign-activate button"
                                        :class="[
                                            companySearch === ''
                                                ? 'button-disabled'
                                                : '',
                                        ]"
                                    >
                                        Sök
                                    </button>
                                </form>
                            </div>
                        </div>

                        <!-- Recommend subscription -->
                        <div
                            class="accordion-item"
                            :class="[
                                accordionsOpen.indexOf(
                                    'recommendedSubscription'
                                ) > -1
                                    ? 'open'
                                    : '',
                            ]"
                            v-if="
                                recommendedProduct &&
                                sales?.subscriptions?.recommedProduct
                            "
                        >
                            <div
                                class="accordion-item-header"
                                @click="
                                    toggleAccordion('recommendedSubscription')
                                "
                            >
                                <h4>Rekommenderat medlemskap</h4>
                                <div>
                                    <i class="material-icons-outlined"
                                        >expand_more</i
                                    >
                                </div>
                            </div>
                            <div class="accordion-item-content">
                                <div></div>

                                <div class="sales-recommended-subscription">
                                    <p>
                                        {{
                                            sales?.subscriptions
                                                ?.recommedProduct?.areaLabel
                                        }}<br />
                                        {{
                                            sales?.subscriptions?.recommedProduct?.includes.join(
                                                ", "
                                            )
                                        }}
                                    </p>
                                    <h4
                                        v-if="
                                            sales?.subscriptions
                                                ?.recommedProduct
                                                ?.periodUnit === 'MONTH'
                                        "
                                    >
                                        {{
                                            sales?.subscriptions
                                                ?.recommedProduct?.periodPrice
                                        }}
                                        kr/mån
                                    </h4>
                                    <h4
                                        v-if="
                                            sales?.subscriptions
                                                ?.recommedProduct
                                                ?.periodUnit !== 'MONTH'
                                        "
                                    >
                                        {{
                                            sales?.subscriptions
                                                ?.recommedProduct?.periodPrice
                                        }}
                                        kr
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End of accordions-->

                    <!-- Sale -->
                    <div
                        class="sales-section"
                        v-for="sale in sales.subscriptions.subscriptions"
                    >
                        <div class="sales-section-header">
                            <h3>{{ sale.name }}</h3>
                            <div
                                class="sales-section-header-info"
                                @click="showInfoBox = sale.key"
                            >
                                <i class="material-icons-outlined">info</i>
                            </div>
                        </div>

                        <div class="sales-table-holder">
                            <div class="sales-table">
                                <div class="sales-day">
                                    <div>Alla öppettider</div>
                                    <div>Dagtid vardagar</div>
                                </div>
                                <div class="sales-bindings">
                                    <div class="sales-binding">
                                        <div>12 mån</div>
                                        <div>Obunden</div>
                                        <div>12 mån förskott</div>
                                    </div>
                                    <div class="sales-binding">
                                        <div>12 mån</div>
                                        <div>Obunden</div>
                                        <div>12 mån förskott</div>
                                    </div>
                                </div>

                                <div class="sales-line-name" v-if="sale.bathProducts">
                                    Endast bad
                                </div>

                                <div
                                    class="sales-line"
                                    v-if="sale.bathProducts"
                                >

                                    <SalePrice
                                        :recommendedProduct="recommendedProduct"
                                        :product="sale.bathProducts['12M']"
                                        @click="
                                            selectProduct(
                                                sale.bathProducts['12M']
                                            )
                                        "
                                    />
                                    <SalePrice
                                        :recommendedProduct="recommendedProduct"
                                        :product="sale.bathProducts['NM']"
                                        @click="
                                            selectProduct(
                                                sale.bathProducts['NM']
                                            )
                                        "
                                    />
                                    <SalePrice
                                        :recommendedProduct="recommendedProduct"
                                        :product="sale.bathProducts['12C']"
                                        @click="
                                            selectProduct(
                                                sale.bathProducts['12C']
                                            )
                                        "
                                    />
                                    <div class="sales-no-price"></div>
                                    <div class="sales-no-price"></div>
                                    <div class="sales-no-price"></div>
                                </div>

                                <div class="sales-line-name" v-if="
                                        sale.products.AD.GYM.NB ||
                                        sale.products.AD.GYM['12M'] ||
                                        sale.products.AD.GYM['12C'] ||
                                        sale.products.DT.GYM.NB ||
                                        sale.products.DT.GYM['12M'] ||
                                        sale.products.DT.GYM['12C']
                                    ">Gym</div>

                                <div
                                    class="sales-line"
                                    v-if="
                                        sale.products.AD.GYM.NB ||
                                        sale.products.AD.GYM['12M'] ||
                                        sale.products.AD.GYM['12C'] ||
                                        sale.products.DT.GYM.NB ||
                                        sale.products.DT.GYM['12M'] ||
                                        sale.products.DT.GYM['12C']
                                    "
                                >
                                    
                                    <SalePrice
                                        :recommendedProduct="recommendedProduct"
                                        :product="
                                            sale.products.AD.GYM['12M'][0]
                                        "
                                        @click="
                                            selectProduct(
                                                sale.products.AD.GYM['12M'][0]
                                            )
                                        "
                                    />
                                    <SalePrice
                                        :recommendedProduct="recommendedProduct"
                                        :product="sale.products.AD.GYM['NB'][0]"
                                        @click="
                                            selectProduct(
                                                sale.products.AD.GYM['NB'][0]
                                            )
                                        "
                                    />
                                    <SalePrice
                                        :recommendedProduct="recommendedProduct"
                                        :product="
                                            sale.products.AD.GYM['12C'][0]
                                        "
                                        @click="
                                            selectProduct(
                                                sale.products.AD.GYM['12C'][0]
                                            )
                                        "
                                    />
                                    <SalePrice
                                        :recommendedProduct="recommendedProduct"
                                        :product="
                                            sale.products.DT.GYM['12M'][0]
                                        "
                                        @click="
                                            selectProduct(
                                                sale.products.DT.GYM['12M'][0]
                                            )
                                        "
                                    />
                                    <SalePrice
                                        :recommendedProduct="recommendedProduct"
                                        :product="sale.products.DT.GYM['NB'][0]"
                                        @click="
                                            selectProduct(
                                                sale.products.DT.GYM['NB'][0]
                                            )
                                        "
                                    />
                                    <SalePrice
                                        :recommendedProduct="recommendedProduct"
                                        :product="
                                            sale.products.DT.GYM['12C'][0]
                                        "
                                        @click="
                                            selectProduct(
                                                sale.products.DT.GYM['12C'][0]
                                            )
                                        "
                                    />
                                </div>

                                <div class="sales-line-name" v-if="
                                        sale.products.AD.GX.NB ||
                                        sale.products.AD.GX['12M'] ||
                                        sale.products.AD.GX['12C'] ||
                                        sale.products.DT.GX.NB ||
                                        sale.products.DT.GX['12M'] ||
                                        sale.products.DT.GX['12C']
                                    ">Inkl GT</div>

                                <div
                                    class="sales-line"
                                    v-if="
                                        sale.products.AD.GX.NB ||
                                        sale.products.AD.GX['12M'] ||
                                        sale.products.AD.GX['12C'] ||
                                        sale.products.DT.GX.NB ||
                                        sale.products.DT.GX['12M'] ||
                                        sale.products.DT.GX['12C']
                                    "
                                >
                                    <SalePrice
                                        :recommendedProduct="recommendedProduct"
                                        :product="sale.products.AD.GX['12M'][0]"
                                        @click="
                                            selectProduct(
                                                sale.products.AD.GX['12M'][0]
                                            )
                                        "
                                    />
                                    <SalePrice
                                        :recommendedProduct="recommendedProduct"
                                        :product="sale.products.AD.GX['NB'][0]"
                                        @click="
                                            selectProduct(
                                                sale.products.AD.GX['NB'][0]
                                            )
                                        "
                                    />
                                    <SalePrice
                                        :recommendedProduct="recommendedProduct"
                                        :product="sale.products.AD.GX['12C'][0]"
                                        @click="
                                            selectProduct(
                                                sale.products.AD.GX['12C'][0]
                                            )
                                        "
                                    />
                                    <SalePrice
                                        :recommendedProduct="recommendedProduct"
                                        :product="sale.products.DT.GX['12M'][0]"
                                        @click="
                                            selectProduct(
                                                sale.products.DT.GX['12M'][0]
                                            )
                                        "
                                    />
                                    <SalePrice
                                        :recommendedProduct="recommendedProduct"
                                        :product="sale.products.DT.GX['NB'][0]"
                                        @click="
                                            selectProduct(
                                                sale.products.DT.GX['NB'][0]
                                            )
                                        "
                                    />
                                    <SalePrice
                                        :recommendedProduct="recommendedProduct"
                                        :product="sale.products.DT.GX['12C'][0]"
                                        @click="
                                            selectProduct(
                                                sale.products.DT.GX['12C'][0]
                                            )
                                        "
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End of Sale -->

                    <!-- Crossfit -->
                    <div
                        class="sales-section"
                        v-if="
                            sales?.crossfit?.NB ||
                            sales?.crossfit?.['12M'] ||
                            sales?.crossfit?.['12C']
                        "
                    >
                        <div class="sales-section-header">
                            <h3>Crossfit</h3>
                            <div
                                class="sales-section-header-info"
                                @click="showInfoBox = 'crossfit'"
                            >
                                <i class="material-icons-outlined">info</i>
                            </div>
                        </div>

                        <div class="sales-day">
                            <div>Alla öppettider</div>
                        </div>
                        <div class="sales-bindings">
                            <div class="sales-binding">
                                <div>12 mån</div>
                                <div>Obunden</div>
                                <div>12 mån förskott</div>
                            </div>
                        </div>

                        <div class="sales-line">
                            <div class="sales-line-name"></div>
                            <SalePrice
                                :recommendedProduct="recommendedProduct"
                                :product="sales?.crossfit?.['12M']"
                                @click="selectProduct(sales?.crossfit?.['12M'])"
                            />
                            <SalePrice
                                :recommendedProduct="recommendedProduct"
                                :product="sales?.crossfit?.NB"
                                @click="selectProduct(sales?.crossfit?.['NB'])"
                            />
                            <SalePrice
                                :recommendedProduct="recommendedProduct"
                                :product="sales?.crossfit?.['12C']"
                                @click="selectProduct(sales?.crossfit?.['12C'])"
                            />

                            <div class="sales-no-price"></div>
                            <div class="sales-no-price"></div>
                            <div class="sales-no-price"></div>
                        </div>
                    </div>

                    <!-- End of crossfit -->

                    <!-- Clipcards -->
                    <div
                        class="sales-section"
                        v-for="productCategory in sales.products"
                    >
                        <div class="sales-section-header">
                            <h3>{{ productCategory.name }}</h3>
                        </div>

                        <div class="sales-other-products">
                            <div
                                @click="selectProduct(clipcard.clipcardItem)"
                                class="sales-other-product"
                                v-for="clipcard in productCategory.products"
                            >
                                <p>{{ clipcard.clipcardItem.name }}</p>
                                <div class="sales-other-product-price">
                                    <span
                                        v-if="
                                            clipcard?.clipcardItem.price &&
                                            clipcard?.clipcardItem.price ===
                                                clipcard?.clipcardItem
                                                    .normalPrice
                                        "
                                    >
                                        {{
                                            Math.ceil(
                                                clipcard?.clipcardItem.price
                                            )
                                        }}:-
                                    </span>

                                    <span
                                        v-if="
                                            clipcard?.clipcardItem.price &&
                                            clipcard?.clipcardItem.price !==
                                                clipcard?.clipcardItem
                                                    .normalPrice
                                        "
                                    >
                                        <span class="text-line-through"
                                            >{{
                                                Math.ceil(
                                                    clipcard?.clipcardItem
                                                        .normalPrice
                                                )
                                            }}:-</span
                                        >
                                        {{
                                            Math.ceil(
                                                clipcard?.clipcardItem.price
                                            )
                                        }}:-
                                    </span>
                                </div>
                                <div
                                    class="sales-other-product-info"
                                    @click.stop="
                                        clipcardInfo.name = clipcard.name;
                                        clipcardInfo.info = clipcard.info;
                                        showInfoBox = 'clipcard';
                                    "
                                >
                                    <i class="material-icons-outlined">info</i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Subscription bar -->
        <div
            class="sales-selected-product sales-selected-product-subscription"
            v-if="
                selectedProduct &&
                selectedProduct?.clips === undefined &&
                selectedProduct.subscriptionType !== 'special' &&
                !checkoutSuccess
            "
        >
            <div class="sales-holder">
                <div class="sales-selected-holder">
                    <div class="sales-selected-product-name">
                        <h2>{{ selectedProduct.areaLabel }}</h2>
                        <div class="sales-selected-center">
                            {{ sales.subscriptions.center.name }}
                        </div>
                        <div
                            @click="deleteProduct()"
                            class="sales-delete-product"
                        >
                            <i class="material-icons-outlined color-blue"
                                >delete</i
                            >
                        </div>
                    </div>
                    <div class="sales-selected-product-info-1">
                        <ul>
                            <li>{{ sales.subscriptions.personTypeLabel }}</li>
                            <li>{{ selectedProduct.areaLabel }}</li>
                            <li
                                v-for="include in selectedProduct.includes"
                                v-html="include"
                            ></li>
                        </ul>
                    </div>
                    <div class="sales-selected-product-info-2">
                        <ul>
                            <li
                                v-if="selectedProduct.creationPriceText !== ''"
                                v-html="selectedProduct.creationPriceText"
                            ></li>

                            <li
                                class="color-red"
                                v-if="selectedProduct?.campaign?.summary !== ''"
                                v-html="selectedProduct.campaign?.summary"
                            ></li>
                        </ul>
                    </div>
                    <div class="sales-selected-product-price-holder">
                        <div
                            v-if="
                                selectedProduct?.subscriptionBinding !== '12C'
                            "
                        >
                            <span>{{ selectedProduct.periodPrice }}</span>
                            kr/mån
                        </div>
                        <div
                            v-if="
                                selectedProduct?.subscriptionBinding === '12C'
                            "
                        >
                            <span>{{ selectedProduct.periodPrice }}</span>
                            kr
                        </div>
                        <div
                            v-if="!showCheckoutForm"
                            @click="goToCheckoutForm()"
                            class="button"
                        >
                            Nästa
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--- End of subscription bar -->

        <!-- Clipcard bar -->
        <div
            class="sales-selected-product sales-selected-product-clipcard"
            v-if="
                selectedProduct &&
                selectedProduct?.clips !== undefined &&
                selectedProduct.subscriptionType !== 'special' &&
                !checkoutSuccess
            "
        >
            <div class="sales-holder">
                <div class="sales-selected-holder">
                    <div class="sales-selected-product-name">
                        <h2>{{ selectedProduct.name }}</h2>
                        <div class="sales-selected-center">
                            {{ sales.subscriptions.center.name }}
                        </div>
                        <div
                            @click="deleteProduct()"
                            class="sales-delete-product"
                        >
                            <i class="material-icons-outlined color-blue"
                                >delete</i
                            >
                        </div>
                    </div>
                    <div class="sales-selected-product-price-holder">
                        <div>
                            <span>{{ selectedProduct.price }}</span>
                            kr
                        </div>
                        <div
                            v-if="!showCheckoutForm"
                            @click="goToCheckoutForm()"
                            class="button"
                        >
                            Nästa
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--- End of clipcard bar -->

        <!-- Special subscription bar -->
        <div
            class="sales-selected-product sales-selected-product-subscription"
            v-if="
                selectedProduct &&
                selectedProduct?.clips === undefined &&
                selectedProduct.subscriptionType === 'special' &&
                !checkoutSuccess
            "
        >
            <div class="sales-holder">
                <div class="sales-selected-holder">
                    <div class="sales-selected-product-name">
                        <h2>{{ selectedProduct.name }}</h2>
                        <div class="sales-selected-center">
                            {{ sales.subscriptions.center.name }}
                        </div>
                        <div
                            @click="deleteProduct()"
                            class="sales-delete-product"
                        >
                            <i class="material-icons-outlined color-blue"
                                >delete</i
                            >
                        </div>
                    </div>
                    <div
                        class="sales-selected-product-info-1"
                        v-html="selectedProduct?.description"
                    ></div>
                    <div class="sales-selected-product-info-2"></div>
                    <div class="sales-selected-product-price-holder">
                        <div
                            v-html="selectedProduct?.periodPriceFormated"
                        ></div>
                        <div
                            v-if="!showCheckoutForm"
                            @click="goToCheckoutForm()"
                            class="button"
                        >
                            Nästa
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--- End of clipcard bar -->

        <!-- Personsearch -->

        <PersonSearch />

        <div v-if="loading" class="loading loading-with-text">
            <div class="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <div>
                {{ loadingText }}
            </div>
        </div>
    </main>
</template>

<script>
import axios from "axios";
import { toast } from "vue3-toastify";
import { mapStores } from "pinia";
import SalePrice from "./SalePrice.vue";
import "vue3-toastify/dist/index.css";
import { useAuthStore } from "../../stores/auth.js";

export default {
    components: {
        SalePrice,
    },
    computed: {
        ...mapStores(useAuthStore),
    },
    data() {
        return {
            recommendedProduct: false,
            personType: "private",
            settings: {},
            loading: false,
            sales: {
                subscriptions: [],
                clipcards: [],
                products: [],
                crossfit: [],
            },
            selectedProduct: false,
            showCheckoutForm: false,
            customer: {
                name: "",
                lastname: "",
                phone: "",
                email: "",
                otherPayer: false,
                otherPayerName: "",
                otherPayerLastName: "",
                otherPayerPhone: "",
                otherPayerEmail: "",
            },
            customerErrors: [],
            productType: "subscription",
            campaignCode: "",
            selectedCampaign: false,
            showCompanySearchResults: false,
            companySearchResults: [],
            companySearch: "",
            companyCode: "",
            loadingText: "",
            accordionsOpen: [],
            checkoutSuccess: false,
            showInfoBox: false,
            clipcardInfo: {
                name: "",
                info: "",
            },
            exerpError: false,
        };
    },
    mounted() {
        this.loadProducts();

        let validQueries = ["email", "phone", "name", "lastname"];

        validQueries.forEach((query) => {
            if (this.$route.query[query]) {
                this.customer[query] = this.$route.query[query];
            }
        });
    },
    methods: {
        reloadPage() {
            this.loading = true;
            window.location.href = "/app/sales";
        },
        getNumberOfBath() {
            let count = 0;

            if (this.sales?.subscriptions?.maxInfo?.centers === undefined) {
                return "-";
            }

            this.sales.subscriptions.maxInfo.centers.forEach((center) => {
                if (center.has_bath) {
                    count++;
                }
            });
            return count;
        },
        getDefaultText(key) {
            if (this.settings?.defaultCategories === undefined) {
                return false;
            }
            let index = this.settings.defaultCategories.findIndex(
                (x) => x.key === key
            );

            if (index === -1) {
                return false;
            }

            return this.settings.defaultCategories[index].info;
        },
        reload() {
            this.showCheckoutForm = false;
            this.checkoutSuccess = false;
            this.campaignCode = "";
            this.companyCode = "";
            this.customer = {
                name: "",
                lastname: "",
                phone: "",
                email: "",
                otherPayer: false,
                otherPayerName: "",
                otherPayerLastName: "",
                otherPayerPhone: "",
                otherPayerEmail: "",
            };
            this.selectedProduct = false;
            this.selectedCampaign = false;
            this.showCompanySearchResults = false;
            this.companySearchResults = [];
            this.companySearch = "";
            this.loadProducts();
            this.scrollToTop();
        },
        goToCheckoutForm() {
            this.showCheckoutForm = true;
            this.scrollToTop();
        },
        scrollToTop() {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        },
        deleteProduct() {
            this.selectedProduct = false;
            if (this.showCheckoutForm) {
                this.showCheckoutForm = false;
                this.checkoutSuccess = false;
                this.scrollToTop();
            }
        },
        removeCustomerError(key) {
            let index = this.customerErrors.indexOf(key);
            if (index > -1) {
                this.customerErrors.splice(index, 1);
            }
        },
        toggleAccordion(key) {
            let index = this.accordionsOpen.indexOf(key);
            if (index > -1) {
                this.accordionsOpen.splice(index, 1);
            } else {
                this.accordionsOpen.push(key);
            }
        },
        campaignRemove() {
            this.selectedCampaign = false;
            this.campaignCode = "";
            this.loadProducts();
        },
        addPreDefinedCampaignCode(code) {
            console.log(code);
            this.campaignCode = code;
            this.addCampaignCode();
        },
        showLoader(text) {
            this.loadingText = text;
            this.loading = true;
        },
        addCampaignCode() {
            // Check if the campaign code is valid?
            this.loading = true;
            let self = this;

            this.showLoader("Kontrollerar kampanjkod");

            axios
                .post(
                    self.authStore.api + "/sales/validate-campaign-code",
                    {
                        campaignCode: self.campaignCode,
                        centerId: self.authStore.user.current_center.center_id,
                    },
                    {
                        headers: {
                            Authorization: "Bearer " + self.authStore.token,
                        },
                    }
                )
                .then((response) => {
                    console.log(response);

                    if (response.data.status) {
                        if (!response.data.campaign.activeCampaign) {
                            toast("Kampanjkoden är inte giltig", {
                                type: "error",
                                position: "bottom-right",
                                autoClose: 1000,
                                dangerouslySetInnerHTML: true,
                            });
                            self.loading = false;
                        } else {
                            self.loading = false;
                            self.selectedCampaign = response.data.campaign;
                            self.loadProducts();
                            toast("Kampanjkoden tillagd", {
                                type: "success",
                                position: "bottom-right",
                                autoClose: 1000,
                                dangerouslySetInnerHTML: true,
                            });
                        }
                    } else {
                        toast.error("Kampanjkoden är ogiltig");
                        self.loading = false;
                    }
                })
                .catch((error) => {
                    self.loading = false;
                });
        },
        selectCompanyCode(code) {
            console.log("selectCompanyCode");
            this.companyCode = code;
            this.showCompanySearchResults = false;
            this.loadProducts();
        },
        searchCompany() {
            this.loading = true;
            let self = this;
            axios
                .post(
                    self.authStore.api + "/sales/search-company",
                    {
                        name: self.companySearch,
                        centerId: self.authStore.user.current_center.center_id,
                        country: self.authStore.user.current_center.country
                    },
                    {
                        headers: {
                            Authorization: "Bearer " + self.authStore.token,
                        },
                    }
                )
                .then((response) => {
                    console.log(response);
                    if (response.data.status) {
                        self.companySearchResults = response.data.agreeements;
                    }
                    self.showCompanySearchResults = true;
                    self.loading = false;
                })
                .catch((error) => {
                    self.loading = false;
                });
        },
        selectProduct(product) {
            if (product === undefined) {
                return;
            }

            console.log("selectProduct");
            console.log(product.name);
            console.log(product);
            this.selectedProduct = product;
        },
        loadCenter() {
            this.loadProducts();
        },
        checkout() {
            this.customerErrors = [];

            // Validation
            if (this.customer.phone === "") {
                this.customerErrors.push("phone");
            }

            if (this.customer.otherPayer) {
                if (this.customer.otherPayerPhone === "") {
                    this.customerErrors.push("otherPayerPhone");
                }
            }

            if (this.customerErrors.length > 0) {
                return;
            }

            let productType = "subscription";

            if (this.selectedProduct.clips !== undefined) {
                productType = "clipcard";
            }

            this.showLoader("Skickar");
            let self = this;
            axios
                .post(
                    self.authStore.api + "/sales/checkout",
                    {
                        centerId: self.authStore.user.current_center.id,
                        customer: self.customer,
                        product: this.selectedProduct,
                        personType: this.personType,
                        productType: productType,
                        campaignCode: this.campaignCode,
                        companyCode: this.companyCode,
                        soldBy: self.authStore.user.id,
                    },
                    {
                        headers: {
                            Authorization: "Bearer " + self.authStore.token,
                        },
                    }
                )
                .then((response) => {
                    console.log(response);
                    self.checkoutSuccess = true;
                    self.loading = false;
                    this.scrollToTop();
                })
                .catch((error) => {
                    self.loading = false;
                });
        },
        loadProducts() {
            this.selectedProduct = false;
            this.showLoader("Hämtar priser");

            let self = this;
            axios
                .post(
                    self.authStore.api + "/sales/subscriptions",
                    {
                        centerId: self.authStore.user.current_center.id,
                        personType: self.personType,
                        campaignCode: self.campaignCode,
                        companyCode: this.companyCode,
                    },
                    {
                        headers: {
                            Authorization: "Bearer " + self.authStore.token,
                        },
                    }
                )
                .then((response) => {
                    console.log(response);
                    self.sales.subscriptions = response.data.subscriptions;
                    self.sales.clipcards = response.data.clipcards;
                    self.sales.products = response.data.products;
                    self.sales.crossfit = response.data.subscriptions.crossfit;
                    self.settings = response.data.settings;
                    self.exerpError = response.data.exerp_error;

                    console.log(response.data.settings.recommended);

                    if (
                        response.data.settings.recommended[
                            this.authStore.user.current_center.id
                        ] !== undefined
                    ) {
                        self.recommendedProduct =
                            response.data.settings.recommended[
                                this.authStore.user.current_center.id
                            ];
                    }

                    self.loading = false;
                })
                .catch((error) => {
                    self.loading = false;
                });
        },
    },
};
</script>

<style>
.sales-header {
    width: calc(100% - 40px);
    max-width: 1070px;
    margin: 0 auto;
    padding: 20px 0;

    h1 {
        font-size: 22px;
        line-height: 30px;

        @media (min-width: 1070px) {
            font-size: 50px;
            line-height: 60px;
        }
    }
}

.sales {
    background-color: #fff;
    min-height: 100vh;
    padding-bottom: 150px;
    width: 100%;
    width: calc(100% + 28px);
    margin-left: -14px;

    @media (min-width: 1070px) {
        width: calc(100% + 56px);
        margin-left: -28px;
    }
}

.sales-holder {
    width: calc(100% - 40px);
    max-width: 850px;
    margin: 0 auto;
    padding: 40px 0;
}

.sales-section {
    display: flex;
    flex-direction: column;
    font-size: 12px;
    margin-bottom: 80px;

    .sales-line:last-child {
        border-bottom: 1px solid #d9d8d6;
    }
}

.sales-section-header {
    font-family: "hansen-grotesque-bold", sans-serif;
    font-size: 16px;
    padding: 5px 15px;
    border-radius: 6px 6px 0 0;
    background-color: #282828;
    color: #fff;
    display: flex;
    justify-content: space-between;

    h3 {
        font-size: 23px;
        letter-spacing: -1px;
    }

    .sales-section-header-info {
        width: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
}

.sales-day {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    font-family: "hansen-grotesque-bold", sans-serif;
    width: 100%;
    margin-left: 90px;

    div {
        width: 50%;
        text-align: center;
        padding: 20px 20px 3px 20px;
    }
}

.sales-bindings {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #d9d8d6;
    width: 100%;
    margin-left: 90px;
}

.sales-binding {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 50%;
    font-family: "helvetica-regular";
    font-size: 12px;

    div {
        width: 33.33%;
        text-align: center;
        padding: 20px 20px 10px 20px;
    }
}

.sales-table-holder {
    overflow-x: auto;

    @media (min-width: 800px) {
        overflow-x: unset;
        margin-left: -90px;
    }

    .sales-table {
        min-width: 740px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }
}

.sales-line {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: calc(100% - 100px);
    position: relative;

    > div {
        width: 33.33%;
        text-align: center;
        padding: 28px 20px;
        font-family: "hansen-grotesque-bold", sans-serif;
        font-size: 13px;
        color: #0033ff;
        cursor: pointer;
        transition: 0.2s ease all;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        letter-spacing: 1px;

        &:hover {
            background-color: #d9d8d6;
            transition: 0.2s ease all;
        }

        &.sales-line-name {
            position: absolute;
            left: -110px;
            width: 110px;
            text-align: left;
            font-family: "helvetica-regular";
            font-size: 12px;
            color: #000;
            padding: 28px 2px;
            cursor: default;

            &:hover {
                background-color: #fff;
                transition: 0.2s ease all;
            }
        }
    }

    div:nth-child(3) {
        border-right: 1px solid #d9d8d6;
    }
}

.sales-normal-price {
    color: #000;
    text-decoration: line-through;
    font-weight: 400;
    font-family: "hansen-grotesque-regular";
    margin-bottom: 5px;
}

.sales-extra-price {
    color: #b1144e;
    font-weight: 700;
}

.sales-extra-price-holder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.sales-person-types {
    display: flex;
    margin-bottom: 10px;
    flex-direction: column;

    @media (min-width: 500px) {
        margin-bottom: 40px;
        margin-top: 80px;
        flex-direction: row;
    }

    .sales-person-type {
        width: 190px;
        label {
            cursor: pointer;
        }
        margin-bottom: 20px;
    }

    input {
        margin: 0 12px 0 0;
    }

    label {
        margin-bottom: 0;
        font-style: normal;
        font-size: 13px;
        text-transform: none;
        color: #000;
        letter-spacing: 0.5px;
        display: flex;
        font-family: "hansen-grotesque-bold";
        font-weight: 700;

        @media (min-width: 500px) {
            font-size: 15px;
            font-weight: 400;
            font-family: "helvetica-regular";
        }

    }
}

.accordion {
    display: flex;
    flex-direction: column;
    margin-bottom: 80px;

    .accordion-item-header {
        height: 50px;
        border-bottom: 1px solid #a1b1c8;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;

        div:first-child {
            display: flex;
            align-items: center;

            h4 {
                margin-bottom: 0;
                margin-right: 10px;
            }
        }

        i {
            color: #0033ff;
            transition: all 0.2s ease;
        }
    }

    .accordion-item.open {
        .accordion-item-content {
            display: block;
        }

        .accordion-item-header div:last-child i {
            transform: rotate(180deg);
            transition: all 0.2s ease;
        }
    }

    .accordion-item-content {
        padding: 20px 0;
        display: none;

        p {
            font-size: 12px;
            line-height: 16px;
            margin-bottom: 4px;

            &.color-rock {
                font-family: "helvetica-regular";
            }
        }

        span.code {
            font-size: 12px;
            line-height: 16px;
            color: #b1144e;
            font-weight: 700;
            text-transform: uppercase;
            cursor: pointer;
            font-family: "helvetica-bold";
            letter-spacing: 0.1px;
        }

        .sales-info-campaign {
            margin-bottom: 30px;

            &:last-child {
                margin-bottom: 0;
            }
        }
    }
}

.sales-campaign-holder {
    display: flex;
    flex-direction: column;
    margin-top: 16px;

    > input {
        margin-bottom: 20px;
    }

    @media (min-width: 500px) {
        flex-direction: row;

        > input {
            margin-bottom: 0;
        }
        
        .button {
            margin-left: 30px;
        }
    }
}

.sales-company-codes-header {
    border-bottom: 1px solid #000;
    padding-bottom: 10px;
}

.sales-company-codes {
    display: flex;
    flex-direction: column;
}

.sales-company-code {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 50px;
    padding: 5px 0;
    border-bottom: 1px solid #d9d8d6;

    .button {
        padding: 6px 5px;
        font-size: 10px;
        min-width: 80px;
        min-height: 28px;
        margin-left: 10px;
    }

    &.is-not-active span {
        text-decoration: line-through;
    }

    div {
        display: flex;
        align-items: center;
    }

    a {
        font-size: 14px;
        font-weight: 400;
        font-family: "hansen-grotesque-regular";
        line-height: 18px;
    }

    .sales-city-name {
        font-size: 12px;
        line-height: 16px;
        font-family: "helvetica-regular";
        font-weight: 400;
        color: #617594;
    }
}

.sales-modal {
    .sales-modal-small-text {
        text-align: center;
        color: #617594;
        font-size: 14px;
        line-height: 18px;
        margin-top: 20px;
    }
}

.sales-selected-campaign {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    h4 {
        margin-bottom: 0;
    }

    h5 {
        margin-bottom: 6px;
    }
}

.sales-recommended-subscription {
    border: 1px solid #a1b1c8;
    border-radius: 10px;
    padding: 10px;

    p {
        font-size: 15px !important;
        line-height: 22px !important;
        font-family: "helvetica-regular";
    }
}

.sales-other-products {
    display: flex;
    width: calc(100% + 15px);
    margin-left: -15px;
    flex-wrap: wrap;
}

.sales-other-product {
    width: calc(100% - 15px);
    margin-left: 15px;
    padding: 10px;
    border: 1px solid #d9d8d6;
    margin-top: 20px;
    border-radius: 6px;
    position: relative;
    cursor: pointer;

    @media (min-width: 500px) {
        width: calc(50% - 15px);
    }

    @media (min-width: 800px) {
        width: calc(25% - 15px);
    }

    p {
        max-width: 140px;
        margin-bottom: 8px;
        font-size: 15px;
        line-height: 22px;
        letter-spacing: 0.5px;
        font-family: "helvetica-regular";
    }

    .sales-other-product-price {
        font-size: 13px;
        line-height: 26px;
        font-weight: 700;
        font-family: "hansen-grotesque-bold", sans-serif;
        letter-spacing: 1px;
        color: #0033ff;
    }

    .sales-other-product-info {
        position: absolute;
        top: 7px;
        right: 7px;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #0033ff;
    }
}

/* Selecetd product */

.sales-selected-product {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #fff;
    padding: 20px;
    box-shadow: 0px -2px 10px 0px #00000040;

    .sales-holder {
        padding: 0;
        width: 100%;
    }

    h2 {
        margin-bottom: 10px;
        font-size: 17px;
        line-height: 18px;
        margin-bottom: 0;
        font-family: "hansen-grotesque-bold", sans-serif;
        font-weight: 700;
    }

    ul {
        list-style: disc;
    }

    .h3,
    li {
        font-family: "helvetica-regular";
        font-size: 12px;
        line-height: 16px;
        font-weight: 400;
    }

    .sales-selected-holder {
        display: flex;
        width: 100%;
        flex-wrap: wrap;
    }
}

.sales-selected-product-price-holder {
    display: flex;
    flex-direction: row;
    font-family: "helvetica-regular";
    font-size: 18px;
    letter-spacing: 0.5px;
    font-family: "helvetica-light";

    div:first-child {
        display: flex;
        align-items: flex-end;
        justify-content: center;
        margin-bottom: 10px;
    }

    span:first-child {
        font-size: 34px;
        font-family: "hansen-grotesque-bold", sans-serif;
        font-weight: 700;
    }
}

.sales-selected-center {
    font-size: 10px;
    color: #617594;
    font-family: "hansen-grotesque-bold", sans-serif;
    font-weight: 700;
    letter-spacing: 1px;
    text-transform: uppercase;
    line-height: 26px;
}

.sales-delete-product {
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.sales-form-header {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #a1b1c8;
    height: 50px;
    align-items: center;
    margin-bottom: 20px;
    > div {
        color: #a1b1c8;
        font-size: 12px;
    }
}

.sales-holder input {
    max-width: 100%;
}

.sales-other-payer-holder {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 50px;
}

/* Success */

.sales-success {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;

    p {
        margin-bottom: 40px;
        font-family: "helvetica-light";
        font-size: 20px;
        font-weight: 300;
    }
}

.sales-success-icon {
    font-size: 140px;
    color: #617594;
    margin-bottom: 40px;
}

.sales-info-box {
    width: 100%;
    padding: 8px 10px;
    border: 1px solid #a1b1c8;
    margin-bottom: 10px;
    border-radius: 6px;

    li {
        width: 100%;
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        font-family: "helvetica-regular";
        padding: 5px 0;
        align-items: flex-end;

        > span:first-child {
            color: #617594;
            width: 110px;
            flex-shrink: 0;
        }
    }

    .sales-info-box-price {
        font-size: 17px;
        font-family: "hansen-grotesque-bold", sans-serif;
        font-weight: 700;
        padding-top: 10px;
    }

    &.sales-info-box-last {
        margin-bottom: 40px;
    }
}

.modal-info-content {
    margin-bottom: 30px;

    p {
        padding-bottom: 10px !important;
        margin-bottom: 0 !important;
    }
}

.sales-subscription-features {
    margin-bottom: 30px;

    span {
        font-size: 14px;
        font-weight: 400;
        font-family: "hansen-grotesque-regular";
        line-height: 18px;
    }
}

.sales-selected-product-clipcard {
    justify-content: space-between;

    .sales-selected-holder {
        justify-content: space-between;
    }

    .sales-selected-product-name {
        flex: 1;
    }

    .sales-selected-product-price-holder {
        width: 190px;
        flex-direction: column;
    }
}

.sales-selected-product-subscription {
    .sales-selected-product-name {
        width: 60%;
        display: flex;
        flex-direction: column;
    }

    .sales-selected-product-info-1 {
        width: 40%;
        display: flex;
        flex-direction: column;
        padding-left: 10px;
    }

    .sales-selected-product-info-2 {
        width: 100%;
        display: flex;
        flex-direction: column;
        margin-top: 10px;
        text-align: center;

        ul {
            list-style: none;
        }
    }

    .sales-selected-product-price-holder {
        width: 100%;
        display: flex;
        flex-direction: row;
        margin-top: 20px;
        justify-content: space-between;

        .button {
            margin-left: 20px;
        }
    }
}

.sales-knowledge-bank {
    .modal-card {
        width: 850px;
        padding: 30px;
    }

    .accordion-item {
        margin-bottom: 10px;
    }

    .accordion-item-header {
        border: 1px solid #e7e7e7;
        padding: 10px 20px;

        h4 {
            font-family: "helvetica-regular";
            font-size: 15px;
            font-weight: 400;
        }
    }

    .accordion-item-content {
        border: 1px solid #e7e7e7;
        padding: 0 20px 20px 20px;
        border-top: 1px solid #ffffff;
        top: -1px;
        position: relative;

        p {
            font-size: 14px;
            line-height: 18px;
        }
    }
}

@media (min-width: 800px) {
    .sales-selected-product {
        h2 {
            font-size: 23px;
            line-height: 33px;
        }
    }

    .sales-selected-center {
        font-size: 13px;
        margin-bottom: 10px;
    }

    .sales-selected-product-subscription {
        .sales-selected-product-name {
            width: 32%;
        }

        .sales-selected-product-info-1 {
            width: 22%;
            padding: 0 30px;
        }

        .sales-selected-product-info-2 {
            width: 22%;
            text-align: left;
            padding-right: 30px;
            margin-top: 0;

            ul {
                list-style: disc;
            }
        }

        .sales-selected-product-price-holder {
            flex-direction: column;
            width: 24%;
            margin-top: 0;
            justify-content: flex-end;

            .button {
                margin-left: 0;
            }

            span:first-child {
                margin-right: 10px;
            }
        }
    }
}

.sales-line-name {
    width: 90px;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

</style>
